
import { defineComponent, onMounted, ref } from "vue";
import mAxiosApi from "@/api";

export interface NotifType {
  tnc_seq: number;
  tnc_code: string;
  tnc_libelle: string;
}

let pickerUid = 0;

export default defineComponent({
  name: "contact-notif-picker",
  props: {
    modelValue: {
      type: Array as () => string[],
      default: () => [],
    },
    defaultCodes: {
      type: Array as () => string[],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const uid = ++pickerUid;
    const loading = ref(true);
    const types = ref<NotifType[]>([]);

    const inputId = (code: string) => `contact-notif-${uid}-${code}`;

    const isSelected = (code: string) => props.modelValue.includes(code);

    const emitSelection = (codes: string[]) => {
      emit("update:modelValue", [...new Set(codes)]);
    };

    const toggleType = (code: string, event: Event) => {
      const checked = (event.target as HTMLInputElement).checked;
      if (checked) {
        emitSelection([...props.modelValue, code]);
      } else {
        emitSelection(props.modelValue.filter((c) => c !== code));
      }
    };
    // mounted
    onMounted(async () => {
      try {
        const res = await mAxiosApi.prototype.getAxios("/getNotifTypes");
        types.value = res.results || [];
        const available = new Set(types.value.map((t) => t.tnc_code));
        if (props.modelValue.length === 0 && props.defaultCodes.length > 0) {
          const defaults = props.defaultCodes.filter((c) => available.has(c));
          if (defaults.length > 0) {
            emitSelection(defaults);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      types,
      inputId,
      isSelected,
      toggleType,
    };
  },
});
